/* ============================================================
   TOCO - Ordre des photos sur les cartes produit
   ============================================================
   Règle : photo sur fond blanc en 1er, lifestyle en 2e (survol
   sur desktop), sur toutes les cartes du site.

   Le Liquid applique la convention des fiches (photo 1 lifestyle,
   photo 2 fond blanc) et marque les deux images de la carte :
     <picture data-toco-photo="blanc">  photo affichée
     <picture data-toco-photo-alt>       2e photo
   Ce script vérifie la photo réellement affichée (coins blancs =
   fond blanc) et inverse les deux si la fiche ne suit pas la
   convention.
   ============================================================ */
(function () {
  if (window.__tocoPhotoOrder) return;
  window.__tocoPhotoOrder = true;

  function hasWhiteBackground(img) {
    try {
      var size = 40;
      var canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, size, size);
      var last = size - 2;
      var mid = size / 2;
      var points = [[1, 1], [last, 1], [1, last], [last, last], [mid, 1], [1, mid], [last, mid]];
      var white = 0;
      for (var i = 0; i < points.length; i++) {
        var d = ctx.getImageData(points[i][0], points[i][1], 1, 1).data;
        if (d[0] > 232 && d[1] > 232 && d[2] > 232) white++;
      }
      return white >= 5;
    } catch (e) {
      return null;
    }
  }

  function currentSrcset(picture) {
    var source = picture.querySelector('source[data-toco-mobile]');
    return source ? source.getAttribute('srcset') : picture.querySelector('img').getAttribute('srcset');
  }

  function setSrcset(picture, srcset) {
    var source = picture.querySelector('source[data-toco-mobile]');
    if (!source) {
      source = document.createElement('source');
      source.setAttribute('data-toco-mobile', '');
      picture.insertBefore(source, picture.firstChild);
    }
    source.setAttribute('sizes', picture.querySelector('img').getAttribute('sizes') || '50vw');
    source.setAttribute('srcset', srcset);
  }

  function check(img) {
    var picture = img.parentElement;
    if (!picture || !picture.hasAttribute('data-toco-photo') || picture.hasAttribute('data-toco-checked')) return;
    if (!img.naturalWidth) return;
    picture.setAttribute('data-toco-checked', '');

    var isWhite = hasWhiteBackground(img);
    if (isWhite === null) return;
    var wantWhite = picture.getAttribute('data-toco-photo') === 'blanc';
    if (isWhite === wantWhite) return;

    var list = picture.closest('.splide__list');
    var other = list && list.querySelector('picture[data-toco-photo-alt]');
    if (!other) return;

    var current = currentSrcset(picture);
    setSrcset(picture, currentSrcset(other));
    setSrcset(other, current);
  }

  document.addEventListener('load', function (event) {
    if (event.target && event.target.tagName === 'IMG') check(event.target);
  }, true);

  function scan() {
    document.querySelectorAll('picture[data-toco-photo] img').forEach(function (img) {
      if (img.complete) check(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
